import styled from "styled-components";

export const RelatoriosPageStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  left: 3em;
  top: 57px;
  width: calc(100% - 3em);
  min-height: 60vh;
  padding-bottom: 40px;
  margin-bottom: 100px;

  .page-title {
    margin: 0 0 1rem 0;
  }

  .relatorios-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
    width: 100%;
    max-width: 240px;
    margin: 0 auto 1.5rem auto;
  }

  .relatorios-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.75rem;
    font-size: 1.1rem;
    font-weight: 500;
    color: #6b7280;
    text-decoration: none;
    border: 1.5px solid #d1d5db;
    border-radius: 6px;
    background-color: #fff;
    transition: all 0.15s;
    line-height: 1.5;

    &.active {
      color: #fff;
      background: linear-gradient(267deg, rgb(131, 43, 146) 39%, rgb(160, 69, 176) 100%);
      border-color: transparent;
      font-weight: 600;
    }

    &:hover:not(.active) {
      border-color: rgba(136, 48, 152, 0.5);
      color: rgba(136, 48, 152, 1);
    }
  }

  .relatorios-conteudo {
    width: 100%;
  }

  @media (min-width: 1280px) {
    left: 290px;
    width: calc(100% - 290px);
  }
`;
